


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';

const statistics = namespace('newstatistics')
const show = namespace('event')

@Component({
  name: 'DataScanVisitorsFromTime'
})
export default class DataScanVisitorsFromTime extends Vue {
  @Prop({type: [], default: []}) items!: any
  @Prop({type: String, default: ''}) title!: any

  get getDataShow() {
    const m: any = {
      'ru':['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря'],
      'en':['January','February','March','April','May','June','July','August','September','October','November','December'],
      'de':['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    }
    // console.log(this.$i18n.locale);
    const dateStart: any = new Date(this.shows[0].begin * 1000)
    const dateFinish: any = new Date(this.shows[0].end * 1000)

    const monthStart: any = m[this.$i18n.locale][dateStart.getMonth()]
    const monthFinish: any = m[this.$i18n.locale][dateFinish.getMonth()]

    if (monthStart === monthFinish) {
      return dateStart.getDate() + ' - ' + dateFinish.getDate() + ' ' + monthFinish
    } else {
      return dateStart.getDate() + ' ' + monthStart + ' - ' + dateFinish.getDate() + ' ' + monthFinish
    }

  }

  @statistics.Action('getScanVisitorsFormServer') protected getScanVisitorsFormServer: any
  @show.Getter('shows') protected shows: any


  chartItems: any = []

  lang: any = {
    shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    resetZoom: "Cбросить масштаб1"
  }


  chartOptions = {
    chart: {
      style: {"fontSize": "12px"},
      zoomType: 'x',
      height: '300',
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '80',
      marginBottom: '50',
      colorCount: 50,
    },
    loading: {
      hideDuration: 1000,
      showDuration: 1000
    },
    title: {
      text: ''
    },
    subtitle: {
      text:
        document.ontouchstart === undefined
          ? this.$t('statistic.collectedDataChart.subtitle')
          : this.$t('statistic.collectedDataChart.subtitleTouched')
    },
    credits: {
      enabled: false
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: {
      allowDecimals: false,
      title: {
        text: this.$t('newstatistics.general.scans')
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        lineColor: '#2D9CDB'
      },
      areaspline: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: [
            [0, '#1B84D0'],
            [1, '#ced6e5']
          ]
        },
        marker: {
          lineWidth: 2,
          symbol: 'circle',
          radius: 3,
          enabledThreshold: 2,
          fillColor: '#ffffff',
          lineColor: '#2D9CDB'
        },
        lineWidth: 4,
        states: {
          hover: {
            lineWidth: 1
          }
        },
        threshold: null
      }
    },
    series: [
      {
        type: 'areaspline',
        name: this.$t('newstatistics.general.scans_badges'),
        data: this.chartItems
      },

    ]
  }


  @Watch('items')
  getItems(NewVal: any) {
    this.updateSeries()
  }

  mounted(): void {
    this.updateSeries()
  }

  protected updateSeries(): void {
    const ar = JSON.parse(JSON.stringify(this.items))
    this.chartItems = ar.map((ele: any) => {
      ele[0] = ele[0] * 1000
      return [ele[0], ele[1]]
    })
    const elem: any = this.$refs.charts

    // elem.setOptions.update({
    //   lang: {
    //     months: [
    //       'Janvier', 'Février', 'Mars', 'Avril',
    //       'Mai', 'Juin', 'Juillet', 'Août',
    //       'Septembre', 'Octobre', 'Novembre', 'Décembre'
    //     ],
    //     weekdays: [
    //       'Dimanche', 'Lundi', 'Mardi', 'Mercredi',
    //       'Jeudi', 'Vendredi', 'Samedi'
    //     ]
    //   }
    // });



    elem.chart.update({
      series: [
        {
          name: this.$t('newstatistics.general.scans') ,
          data: this.chartItems
        }
      ]
    })


    // elem.chart.options.
    // lang = {
    //   decimalPoint: ' and after the dot is ',
    //   shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    //   months: ['Janvier', 'F├®vrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Ao├╗t', 'Septembre', 'Octobre', 'Novembre', 'D├®cembre'],
    //   weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
    // }
    //
    // elem.chart.update({
    //   lang: {
    //     decimalPoint: ' and after the dot is ',
    //     shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    //     months: ['Janvier', 'F├®vrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Ao├╗t', 'Septembre', 'Octobre', 'Novembre', 'D├®cembre'],
    //     weekdays: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
    //   }
    // })
    // elem.chart.redraw()
  }
}
